export default Object.freeze({
  RATES: "/administrator/rates",
  INVOICE_BULK_UPLOAD: "/scinvoice/bulk-upload",
  TF_INVOICE_BULK_UPLOAD: "/tf-invoice/bulk-upload",
  INVOICE_LOG: "/supply-chain/invoice/audit",
});
